<template>
  <!-- PREHLED ZARIZENI -->
  <div class="list-page">
    <div v-if="project && project.projectId != 'undefined'">
      <div class="layout__content__header d-flex flex-column list-page__header layout__content__header--white">
        <CopyNotification
          :opened="copyConfirmVisible"
          :text="'zkopirovanoDoSchranky'"
          @close="copyConfirmVisible = false"
        />

        <div v-if="project" class="d-flex flex-wrap mb-4 mb-sm-0 justify-content-between">
          <h1 class="mb-1 mb-sm-4">
            {{ $t("HTTP_ZARIZENI") }}
          </h1>
          <div
            v-if="project.projectId && project.projectId != 'undefined'"
            class="list-page__buttons d-none d-sm-flex align-items-center justify-content-between"
          >
            <RouterLink
              :to="{ name: 'import', params: { tags: tags } }"
              class="btn btn-primary d-flex align-items-center justify-content-center"
            >
              <div class="atom-icon">
                <img src="@/assets/icons/actions/ico-btn-nova.svg" />
              </div>
              {{ $t("importZarizeni") }}
            </RouterLink>
          </div>
        </div>

        <DeviceSearch
          :project-id="projectId"
          :reload-items="reloadItems"
          :update-responsive-table="updateResponsiveTable"
          technology="mqtt"
          @search="search = $event"
          @all-projects="isSearchThroughAllProjects = $event"
        />

        <ExtendedSearch v-if="enabledExtendedSearch" @set-filter-data="setFilterData($event)" />
      </div>
      <div class="layout__content__header layout__content__header--white pt-0 pb-0">
        <RadioHelp
          :article-link="'/devices/http'"
          :show="showHelp"
          @change-radio-btn-visibility="changeRadioBtnVisibility($event)"
          @update-show-radio-help="showRadioHelp($event)"
        />
      </div>
      <div v-if="radioSlides.length" class="detail-page__tabs__header d-flex">
        <div class="d-flex align-items-end detail-page__tabs__wrapper mt-5">
          <RadioOpenClose
            :radio-slides="radioSlides"
            :show="showHelp"
            @update-show-radio-help="showRadioHelp($event)"
          />
        </div>
      </div>
      <div v-if="allDevices && allDevices.length > 0" class="layout__content__content pt-4 pt-md-5">
        <div v-click-outside="closeDropdownActions" class="dropdown-actions">
          <button
            v-if="selectedRows.length > 0"
            class="btn btn-primary d-flex align-items-center"
            @click="showDropdownActions()"
          >
            {{ $t("hromadneAkce") }}
            <img class="ml-2" src="@/assets/icons/arrows/arr-down-white.svg" />
          </button>
          <button v-else class="btn btn-primary d-flex align-items-center" disabled>
            {{ $t("hromadneAkce") }}
            <img class="ml-2" src="@/assets/icons/arrows/arr-down-white.svg" />
          </button>
          <div
            v-if="isActionsDropdownVisible && selectedRows.length > 0"
            class="dropdown-actions__wrapper dropdown-actions__wrapper--wide"
          >
            <div class="dropdown-actions__inner">
              <div class="row">
                <div
                  class="dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12"
                  @click="exportDevices('xlsx')"
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/icon_xlsx.svg" />
                  </div>
                  {{ $t("LABEL_EXPORT_XLSX") }}
                </div>
                <!--b-col cols="6" class="dropdown-actions__item d-flex align-items-center" @click="toggleSideBox(1)">
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/ico-ico-zmenitsluzbu.svg">
                  </div>
                  {{ $t("zmenitSluzbu") }}
                </b-col-->
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-end mb-md-4 mt-3 mt-md-0">
          <span class="font-weight-light">{{ $t("vybrano") }}: {{ selectedRows.length }}</span>
          <span v-if="selectedRows.length > 0" class="link ml-2" @click="selectAll('deselect')">
            {{ $t("OdvybratVse") }}
          </span>
        </div>

        <div class="position-relative w-100">
          <div id="mqtt" class="table-responsive">
            <table class="table table-main table-hover">
              <thead>
                <tr>
                  <th
                    v-for="(column, index) in columns"
                    :key="index"
                    :class="{ isHidden: !column.visible }"
                    :style="{ 'min-width': column.minWidth }"
                  >
                    <span v-if="column.sortable != true">
                      {{ $t(column.name) }}
                    </span>
                    <span v-else>
                      <div
                        v-if="column.name == 'custDeviceName'"
                        :class="{ checked: allOnPageSelected() }"
                        class="custom-control custom-control--checkbox"
                        @click="selectAll()"
                      >
                        <input class="custom-control-input" type="checkbox" />
                      </div>
                      <div class="title" @click="sortItemsBy(column.sortBy)">
                        {{ $t(column.name) }}
                      </div>
                      <div v-if="sortBy == column.sortBy" class="sorting">
                        <span v-if="sortType == 'desc'">▼</span>
                        <span v-if="sortType == 'asc'">▲</span>
                      </div>
                    </span>
                  </th>
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, item_index) in allDevices" :key="item_index">
                  <td
                    v-for="(column, column_index) in columns"
                    :key="column_index"
                    :class="{ isHidden: !column.visible }"
                    :style="{ width: column.minWidth }"
                  >
                    <span v-if="column.type == 'custDeviceName'">
                      <div
                        :class="{
                          checked: selectedRows.filter((e) => e.deviceId === item.deviceId).length > 0
                        }"
                        class="custom-control custom-control--checkbox"
                        style="display: inline-block"
                        @click="addToSelected(item)"
                      >
                        <input class="custom-control-input" type="checkbox" />
                      </div>

                      <RouterLink
                        :to="{
                          name: 'mqttDevice',
                          params: {
                            id: item.deviceId,
                            device: item,
                            customerId: customerId,
                            projectId: projectId
                          }
                        }"
                        class="font-weight-bolder link-gray"
                      >
                        <span
                          :style="{
                            maxWidth: column.minWidth,
                            minWidth: column.minWidth
                          }"
                          style="display: block; word-wrap: break-word"
                        >
                          {{ item[column.type] }}
                        </span>
                      </RouterLink>
                    </span>
                    <span v-else-if="column.type == 'deviceId'">
                      <div v-tooltip :title="item.deviceId">
                        <span class="eui-short">
                          {{ $filters.strLimitEnd(item.deviceId, 6) }}
                        </span>
                        <span class="eui-full">{{ item.deviceId }}</span>
                      </div>
                      <div class="ml-2 copy d-flex align-items-center" @click="copyToClipboard(item.deviceId)">
                        <img src="@/assets/icons/actions/ico-ico-copy.svg" />
                      </div>
                    </span>
                    <span v-else-if="column.type == 'topicIn'">
                      <div v-tooltip :title="getTopicIn(item.deviceId)">
                        <span class="eui-short">
                          {{ $filters.strLimitEnd(getTopicIn(item.deviceId), 6) }}
                        </span>
                        <span class="eui-full">
                          {{ getTopicIn(item.deviceId) }}
                        </span>
                      </div>
                      <div
                        class="ml-2 copy d-flex align-items-center"
                        @click="copyToClipboard(getTopicIn(item.deviceId))"
                      >
                        <img src="@/assets/icons/actions/ico-ico-copy.svg" />
                      </div>
                    </span>
                    <div v-else-if="column.type == 'deviceGroups'">
                      <div
                        v-for="group in item.deviceGroups.slice(0, 1)"
                        :key="group.deviceGroupId + 'g' + item.deviceId"
                        class="d-flex"
                      >
                        <a
                          class="link-gray"
                          @click="
                            $router.push({
                              name: 'group',
                              params: { id: group.deviceGroupId, group: group }
                            })
                          "
                        >
                          <span>
                            {{ $filters.strLimit(group.deviceGroupName, 25) }}
                          </span>
                        </a>
                        <div v-if="item.deviceGroups.length > 1" class="atom-expand" @click="toggleGroup(item)">
                          <span v-if="openedGroups.indexOf(item) > -1">-</span>
                          <span v-else>+</span>
                          {{ item.deviceGroups.length - 1 }}
                        </div>
                      </div>

                      <div v-if="openedGroups.indexOf(item) > -1" class="atom-expand__content d-flex flex-wrap">
                        <div
                          v-for="group in item.deviceGroups.slice(1, item.deviceGroups.length)"
                          :key="group.deviceGroupId + 'g' + item.device"
                          class=""
                        >
                          <a
                            class="link-gray"
                            @click="
                              $router.push({
                                name: 'group',
                                params: {
                                  id: group.deviceGroupId,
                                  group: group
                                }
                              })
                            "
                          >
                            <span>{{ group.deviceGroupName }}</span>
                          </a>
                        </div>
                      </div>

                      <div class="" />
                    </div>
                    <span v-else-if="column.type == 'status'">
                      <div v-if="item.status == 'preregistration'" class="atom-circle atom-circle--warning">
                        <div v-tooltip :title="$t('PREDREGISTRACE')">P</div>
                      </div>
                      <div
                        v-else-if="item.suspended == false && item.enabled == true"
                        class="atom-circle atom-circle--success"
                      >
                        <div v-tooltip :title="$t('activeZarizeniCerpaSluzbu')">A</div>
                      </div>
                      <div
                        v-else-if="item.suspended == true && item.enabled == true"
                        class="atom-circle atom-circle--danger"
                      >
                        <div v-tooltip :title="$t('overLimitZarizeniPrekrociloLimit')">0</div>
                      </div>

                      <div v-else-if="item.enabled == false" class="atom-circle atom-circle--gray">
                        <div v-tooltip :title="$t('standByZarizeniJeNeaktivni')">S</div>
                      </div>
                    </span>
                    <div v-else-if="column.type == 'tags'">
                      <TagBubbles :is-open="openedTags.includes(item)" :tag-list="item.tags" />
                    </div>

                    <span v-else-if="column.type == 'lastMessageIn'">
                      <span v-if="item.lastMessageIn != null">
                        {{ $t("pred") }}
                        {{ $filters.beforeTime(item.lastMessageIn, "short") }}
                      </span>
                    </span>

                    <span v-else>
                      {{ item[column.type] }}
                    </span>
                  </td>
                  <td>
                    <div
                      id="kebab"
                      ref="kebab"
                      :class="{
                        opened: openedDevice.deviceId == item.deviceId
                      }"
                      class="kebab"
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <table :class="{ showShadow: showShadow }" class="table table-hover fixed-first-column">
              <thead>
                <tr>
                  <th>
                    <span v-if="columns[0].sortable != true">
                      {{ $t(columns[0].name) }}
                    </span>
                    <span v-else class="d-flex align-items-center">
                      <div
                        v-if="columns[0].name == 'custDeviceName'"
                        :class="{ checked: allOnPageSelected() }"
                        class="custom-control custom-control--checkbox"
                        @click="selectAll()"
                      >
                        <input class="custom-control-input" type="checkbox" />
                      </div>
                      <div class="title" @click="sortItemsBy(columns[0].sortBy)">
                        {{ $t(columns[0].name) }}
                      </div>
                      <div v-if="sortBy == columns[0].sortBy" class="sorting">
                        <span v-if="sortType == 'desc'">▼</span>
                        <span v-if="sortType == 'asc'">▲</span>
                      </div>
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, item_index) in allDevices" :key="item_index">
                  <td :style="{ width: columns[0].minWidth }">
                    <span>
                      <div
                        :class="{
                          checked: selectedRows.filter((e) => e.deviceId === item.deviceId).length > 0
                        }"
                        class="custom-control custom-control--checkbox"
                        style="display: inline-block"
                        @click="addToSelected(item)"
                      >
                        <input class="custom-control-input" type="checkbox" />
                      </div>

                      <RouterLink
                        :to="{
                          name: 'mqttDevice',
                          params: {
                            id: item.deviceId,
                            device: item,
                            customerId: customerId,
                            projectId: projectId
                          }
                        }"
                        class="font-weight-bolder link-gray"
                      >
                        <span
                          :style="{
                            maxWidth: columns[0].minWidth,
                            minWidth: columns[0].minWidth
                          }"
                          style="display: block; word-wrap: break-word"
                        >
                          {{ item.custDeviceName }}
                        </span>
                      </RouterLink>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>

            <table :class="{ showShadow: showShadow }" class="table table-hover fixed-last-column">
              <thead>
                <tr>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, item_index) in allDevices" :key="item_index">
                  <td>
                    <div
                      id="kebab"
                      ref="kebab"
                      :class="{
                        opened: openedDevice.deviceId == item.deviceId
                      }"
                      class="kebab"
                    >
                      <div class="dropdown-actions">
                        <div class="atom-icon d-block mr-0" @click="openKebab(item)">
                          <img src="@/assets/icons/menu/ico-kebab.svg" />
                        </div>
                        <div
                          v-if="openedDevice.deviceId == item.deviceId"
                          v-click-outside="closeKebabConf"
                          class="dropdown-actions__wrapper"
                        >
                          <div class="dropdown-actions__inner">
                            <!--
                        <div
                          class="dropdown-actions__item d-flex align-items-center"
                        >
                          <router-link
                            :to="{
                              name: 'mqttDevice',
                              params: {
                                id: item.deviceId,
                                device: item,
                                customerId: customerId,
                                projectId: projectId
                              }
                            }"
                          >
                            {{ $t("detailZarizeni") }}
                          </router-link>
                        </div>-->
                            <div
                              class="dropdown-actions__item d-flex align-items-center"
                              @click="
                                () => {
                                  actionItems = [openedDevice]
                                  toggleEditDeviceModal('editMqttDevice')
                                }
                              "
                            >
                              <div class="atom-icon">
                                <img src="@/assets/icons/actions/ico-ico-upravitzarizeni.svg" />
                              </div>
                              {{ $t("upravitZarizeni") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="itemsCount > 0" class="custom-table__footer w-100 d-flex align-items-center justify-content-between">
          <div class="w-50" />
          <Paging
            :page="{
              currentPage: page,
              rowsPerPage: rowsPerPage,
              itemsTotalCount: itemsCount,
              itemsCount: allDevices.length
            }"
            @page="page = $event"
            @next-page="page++"
            @prev-page="page--"
            @reload-items="reloadItems()"
            @rows-per-page="rowsPerPage = $event"
          />
        </div>
      </div>
      <div v-else-if="!loadingData" class="layout__content__content pt-4 pt-md-5">{{ $t("nicKZobrazeni") }}.</div>
      <div v-else class="layout__content__content pt-4 pt-md-5">
        <AppLoader />
      </div>
    </div>

    <div v-else>
      <div class="layout__content__header list-page__header">
        <div class="d-flex flex-wrap mb-4 mb-sm-0 justify-content-between">
          <h1 class="mb-1 mb-sm-4">
            {{ $t("zarizeni") }}
          </h1>
        </div>
      </div>
    </div>

    <DeleteDeviceModal
      :centered="true"
      :items="actionItems"
      :opened="openedDeleteDevice"
      :text="deleteText"
      @close="toggleDeleteDevice()"
      @yes="
        () => {
          deleteDevice()
          toggleDeletDevice()
        }
      "
    />
    <!--
    <add-to-groups-modal
      :devices="actionItems"
      :opened="openedAddToGroups"
      @openBox="toggleAddToGroupsModal"
      @closeBox="toggleAddToGroupsModal"
      @reloadItems="reloadItems()"
    />
    <send-message
      :devices="actionItems"
      :opened="openedSendMessage"
      @openBox="toggleSendMessageModal"
      @closeBox="toggleSendMessageModal"
    />
    <add-tags
      :devices="actionItems"
      :opened="openedAddTags"
      @openBox="toggleAddTagsModal"
      @closeBox="toggleAddTagsModal"
    />
    <remove-tags
      :devices="actionItems"
      :opened="openedRemoveTags"
      @openBox="toggleRemoveTagsModal"
      @closeBox="toggleRemoveTagsModal"
    />
    <change-status-modal
      :devices="actionItems"
      :opened="openedChangeStatusModal"
      @openBox="toggleChangeStatusModal"
      @closeBox="toggleChangeStatusModal"
    />
    <change-service-modal
      v-if="actionItems[0]"
      :device="actionItems[0]"
      :opened="openedChangeServiceModal"
      @openBox="toggleChangeServiceModal"
      @closeBox="toggleChangeServiceModal"
    />
    <remove-from-groups-modal
      :devices="actionItems"
      :opened="openedRemoveFromGroups"
      @openBox="toggleRemoveFromGroupsModal"
      @closeBox="toggleRemoveFromGroupsModal"
      @reloadItems="reloadItems()"
    />
    <show-message
      :opened="openedMessageDetail"
      :device="deviceToShow"
      :item="messageToShow"
      @closeBox="toggleShowMessage"
    />-->
    <EditMqttDeviceModal
      v-if="openedEditDevice.length > 0"
      :device="actionItems[0]"
      :opened="openedEditDevice"
      :reload-attributes="reloadEditedDevice"
      :tags="tags"
      :transformations="transformations"
      @close-box="toggleEditDeviceModal"
      @open-box="toggleEditDeviceModal"
      @reload-items="reloadItems()"
    />
    <TableColumnOrder
      v-if="showSidebarTableColumnOrder"
      :columns="tableColumns"
      :columns-type="columnsTypeName"
      :opened="showSidebarTableColumnOrder"
      @close-box="closeSidebarTableColumnOrder()"
    />
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
    </div>
  </div>
</template>
<!-- push test -->

<script>
import _ from "lodash"
import axios from "axios"
import Paging from "@/components/paging/paging.vue"
import RadioHelp from "@/components/radio/radio-help.vue"
import RadioOpenClose from "@/components/radio/radio-open-close.vue"
import DeleteDeviceModal from "@/components/confirmations/delete.vue"
import EditMqttDeviceModal from "@/components/modals/devices/editMqtt.vue"
import TableColumnOrder from "@/components/modals/global/tableColumnOrder.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import ExtendedSearch from "@/components/search/search-devices.vue"
import Notify from "@/components/notify/notify.vue"
import Loader from "@/components/loader.vue"
import DeviceSearch from "@/components/devices/partials/DeviceSearch.vue"
import TagBubbles from "./tagBubbles.vue"
import { useProjectStore } from "@/store/modules/project"
import { useConfigStore } from "@/store/modules/config"
import { useLoraStore } from "@/store/modules/devices/lora"
import { useMqttStore } from "@/store/modules/devices/mqtt"

export default {
  directives: {},
  components: {
    DeviceSearch,
    Paging,
    DeleteDeviceModal,
    EditMqttDeviceModal,
    RadioHelp,
    RadioOpenClose,
    ErrorModal,
    CopyNotification: Notify,
    TableColumnOrder,
    ExtendedSearch,
    AppLoader: Loader,
    TagBubbles
  },
  props: {},
  setup() {
    const projectStore = useProjectStore()
    const configStore = useConfigStore()
    const loraStore = useLoraStore()
    const mqttStore = useMqttStore()

    return { projectStore, configStore, loraStore, mqttStore }
  },
  data() {
    return {
      radioSlides: [],
      showHelp: true,
      enabledExtendedSearch: false,
      tableWidth: 0,
      columns: [
        {
          type: "custDeviceName",
          name: "custDeviceName",
          sortable: true,
          sortBy: "custDeviceName",
          visible: true,
          minWidth: "250px",
          order: 1
        },
        {
          type: "deviceId",
          name: "idZarizeniMQTT",
          sortable: true,
          sortBy: "deviceId",
          visible: true,
          minWidth: "120px",
          order: 2
        },
        {
          type: "deviceGroups",
          name: "deviceGroups",
          sortable: false,
          visible: true,
          minWidth: "300px",
          order: 3
        },
        {
          type: "status",
          name: "status",
          sortable: true,
          sortBy: "status",
          visible: true,
          minWidth: "100px",
          order: 4
        },
        {
          type: "tags",
          name: "tags",
          sortable: false,
          visible: true,
          minWidth: "100px",
          order: 5
        },
        {
          type: "topicIn",
          name: "topicIn",
          sortable: false,
          visible: true,
          minWidth: "300px",
          order: 6
        },
        {
          type: "lastMessageIn",
          name: "lastMessageIn",
          sortable: true,
          sortBy: "lastMessageIn",
          visible: true,
          minWidth: "150px",
          order: 7
        }
      ],
      columnsTypeName: "columnsDevicesLora",
      projectId: this.$route.params.projectId,
      customerId: this.$route.params.customerId,
      search: "",
      isSearchThroughAllProjects: false,
      isActionsDropdownVisible: false,
      sort: "custDeviceName",
      rowsPerPage: 20,
      page: 0,
      selectedRows: [],
      selectedAll: false,
      isSelectedAllOnPage: false,
      openedSideBox: false,
      openedDevice: {},
      transformations: {},
      openedGroups: [],
      openedTags: [],
      toggledAllRows: false,
      copyConfirmVisible: false,
      openedDeleteDevice: false,
      openedAddToGroups: [],
      openedRemoveFromGroups: [],
      openedChangeStatusModal: [],
      openedChangeServiceModal: [],
      deleteText: "",
      openedMessageDetail: [],
      deviceToShow: {},
      messageToShow: {},
      tags: [],
      openedAddTags: [],
      openedRemoveTags: [],
      openedSendMessage: [],
      openedEditDevice: [],
      actionItems: [],
      reloadEditedDevice: false,
      sortBy: "custDeviceName",
      sortType: "asc",
      loaded: false,
      loadingData: true,
      errorsToTranslate: [],
      openedError: false,
      closeKebabConf: {
        handler: this.closeKebab,
        middleware: this.middlewareKebab,
        events: ["dblclick", "click"],
        isActive: true,
        detectIFrame: true,
        capture: false
      },
      tableColumnsDefault: {
        deviceId: {
          // eui
          show: true,
          order: 2,
          title: "deviceId"
        },
        deviceGroups: {
          // groups
          show: true,
          order: 3,
          title: "deviceGroups"
        },
        status: {
          // status
          show: true,
          order: 4,
          title: "status"
        },
        topicIn: {
          show: true,
          order: 6,
          title: "topicIn"
        },
        tags: {
          // tags
          show: true,
          order: 5,
          title: "tags"
        },
        lastMessageIn: {
          // message
          show: true,
          order: 8,
          title: "lastMessageIn"
        }
      },
      showSidebarTableColumnOrder: false,
      tableColumns: {},
      showShadow: false,
      filterData: [],
      paramFilterData: []
    }
  },
  computed: {
    allDevices() {
      //return this.$store.getters["devices/allLoraDevices"];
      return false
    },
    itemsCount() {
      return this.loraStore.totalCount
    },
    project() {
      return this.projectStore.selectedProject
    },
    allDevicesUnique() {
      let devices = this.allDevices
      let uniqed = _.uniqBy(devices, "deviceId")
      return uniqed
    },
    radioDisabled() {
      return this.configStore.isRadioHelpDisabled
    }
  },
  watch: {
    project() {
      this.loadDevices()
      this.selectedRows = []
    },
    rowsPerPage() {
      this.page = 0
      localStorage.rowsPerPage = this.rowsPerPage
    },
    page() {
      this.isSelectedAllOnPage = false
      var selectedDevices = this.allDevices.slice(
        this.page * this.rowsPerPage,
        this.page * this.rowsPerPage + this.rowsPerPage
      )
      let selectedDevicesId = selectedDevices.map((d) => d.deviceId)
      let selectedAllRowsArray = Array.from(this.selectedRows)
      let allDevicesId = selectedAllRowsArray.map((d) => d.deviceId)
      this.isSelectedAllOnPage = selectedDevicesId.every((ai) => allDevicesId.includes(ai)) ? true : false
    },
    radioDisabled() {
      this.showHelp = !this.radioDisabled
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.updateResponsiveTable)
      window.addEventListener("click", this.updateResponsiveTable)
    })
    this.showHelp = !this.radioDisabled

    if (localStorage.rowsPerPage) {
      this.rowsPerPage = localStorage.rowsPerPage
    } else {
      localStorage.rowsPerPage = this.rowsPerPage
    }

    if (this.project) {
      this.loadDevices()
    }
    this.updateResponsiveTable()
  },
  methods: {
    changeRadioBtnVisibility(radioSlides) {
      this.radioSlides = radioSlides
    },
    showRadioHelp(status) {
      this.showHelp = status
    },
    toggleExtendedSearch() {
      this.enabledExtendedSearch = !this.enabledExtendedSearch
    },
    updateResponsiveTable() {
      this.$updateResponsiveTable(this, "mqtt")
    },
    getTopicIn(deviceId) {
      return this.customerId + "." + this.projectId + ".in." + deviceId
    },
    /**
     * load all lora devices with actual search, sort and paging parameters
     */
    async loadDevices() {
      if (
        this.$route.params.notifications &&
        this.$route.params.notifications[0] &&
        this.$route.params.notifications[0].text
      ) {
        this.$store.commit("modals/setGlobalNotification", this.$route.params.notifications)
      }
      this.filterData = []
      this.filterData.push({
        field: "projectId",
        value: this.projectId
      })
      if (this.paramFilterData.length) {
        let p = 0
        for (p = 0; p < this.paramFilterData.length; p++) {
          this.filterData.push({
            field: this.paramFilterData[p].name,
            value: this.paramFilterData[p].value,

            operator: this.paramFilterData[p].operator
          })
        }
      }
      const success = await this.mqttStore.getList({
        filters: this.filterData,
        search: this.search,
        sort: this.sort,
        sortType: this.sortType,
        rowsPerPage: this.rowsPerPage,
        currentPage: this.page
      })

      if (success) {
        this.loadingData = false
        this.$nextTick(() => {
          this.updateResponsiveTable()
        })
      }
    },
    reloadItems() {
      // this.selectedRows = [];
      this.loadDevices()
    },
    sortItemsBy(sortBy) {
      this.sortBy = sortBy
      if (this.sortType == "asc") {
        this.sortType = "desc"
      } else {
        this.sortType = "asc"
      }
      this.sort = new String(sortBy)
      this.reloadItems()
    },
    setFilterData(filterData) {
      this.paramFilterData = filterData
      this.reloadItems()
    },
    showDropdownActions() {
      this.isActionsDropdownVisible = this.isActionsDropdownVisible ? false : true
    },
    addToSelected(device) {
      console.log("addToSelected")
      console.log(this.selectedRows)
      if (this.selectedRows.filter((e) => e.deviceId === device.deviceId).length > 0) {
        const index = this.selectedRows.map((e) => e.deviceId).indexOf(device.deviceId)

        this.selectedRows.splice(index, 1)
      } else {
        this.selectedRows.push(device)
      }
    },
    selectAll(type) {
      this.isSelectedAllOnPage = true
      var selectedDevices = this.allDevices

      let selectedDevicesId = selectedDevices.map((d) => d.deviceId)
      let selectedAllRowsArray = Array.from(this.selectedRows)
      let allEndpointsId = selectedAllRowsArray.map((d) => d.deviceId)
      if (type === "deselect") {
        this.selectedRows = []
        this.isSelectedAllOnPage = false
      } else if (type === "selectAll") {
        this.selectedRows = [].concat.apply([], this.allDevices)
        this.isSelectedAllOnPage = true
      } else {
        if (selectedDevicesId.every((ai) => allEndpointsId.includes(ai))) {
          let indexes = []
          selectedDevices.forEach((element) => {
            indexes.push(selectedAllRowsArray.indexOf(element))
          })
          this.selectedRows.splice(indexes[0], indexes.length)
        } else {
          let indexes = []
          let same = []
          this.selectedRows.forEach((selected) => {
            let filteredArray = selectedDevices.filter((e) => e.deviceId === selected.deviceId)
            same.push(filteredArray[0])
          })
          same.forEach((element) => {
            if (element != undefined) {
              indexes.push(this.selectedRows.findIndex((obj) => obj.deviceId == element.deviceId))
            }
          })
          for (var i = indexes.length - 1; i >= 0; i--) {
            this.selectedRows.splice(indexes[i], 1)
          }

          this.selectedRows =
            this.selectedRows.length > 0
              ? this.selectedRows.concat.apply(this.selectedRows, selectedDevices)
              : [].concat.apply([], selectedDevices)
        }
      }
    },
    allOnPageSelected() {
      if (this.allDevices.length == this.selectedRows.length) {
        return true
      } else {
        return false
      }
    },
    openKebab(device) {
      this.openedDevice = this.openedDevice == device ? {} : device
    },
    copyToClipboard(text) {
      this.copyConfirmVisible = true
      var input = document.createElement("textarea")
      input.innerHTML = text
      document.body.appendChild(input)
      input.select()
      var result = document.execCommand("copy")
      document.body.removeChild(input)
      return result
    },
    toggleSideBox(box) {
      this.openedSideBox = box == false ? false : box
    },
    toggleGroup(device) {
      var index = this.openedGroups.indexOf(device)
      if (this.openedGroups.indexOf(device) > -1) {
        this.openedGroups.splice(index, 1)
        if (this.toggledAllRows) this.toggledAllRows = false
      } else {
        this.openedGroups.push(device)
      }
    },
    toggleTag(device) {
      var index = this.openedTags.indexOf(device)
      if (this.openedTags.indexOf(device) > -1) {
        this.openedTags.splice(index, 1)
        if (this.toggledAllRows) this.toggledAllRows = false
      } else {
        this.openedTags.push(device)
      }
    },
    toggleAllRows() {
      if (this.toggledAllRows) {
        this.openedTags = []
        this.openedGroups = []
        this.toggledAllRows = false
      } else {
        this.openedTags = [].concat.apply([], this.allDevices)
        this.openedGroups = [].concat.apply([], this.allDevices)
        this.toggledAllRows = true
      }
    },
    toggleEditDeviceModal(box) {
      if (this.openedEditDevice.indexOf(box) > -1) {
        box == undefined
          ? (this.openedEditDevice = [])
          : this.openedEditDevice.splice(this.openedEditDevice.indexOf(box), 1)

        this.selectedRows = []
        this.selectedAll = false
        if (box == undefined || box == "editMqttDevice") {
          this.openedDevice = {}
        }
      } else {
        this.openedEditDevice.push(box)
        if (box == "editMqttDevice") {
          this.reloadEditedDevice = true
          this.isSelectedAllOnPage = false
          setTimeout(() => {
            this.reloadEditedDevice = false
          }, 1500)
        }
      }
    },
    closeDropdownActions() {
      this.isActionsDropdownVisible = false
    },
    closeKebab() {
      this.openedDevice = {}
    },
    middleware(event) {
      return event.target.className !== "kebab"
    },
    closeSidebarTableColumnOrder() {
      this.tableColumns = this.getTableColumns()
      this.showSidebarTableColumnOrder = false
      this.$updateTableContent(this)
    },
    getTableColumns() {
      const localStorageItemsJSON = localStorage.getItem(this.columnsTypeName)
      if (!localStorageItemsJSON) {
        return this.tableColumnsDefault
      }

      const localStorageItems = JSON.parse(localStorageItemsJSON)

      if (Object.keys(localStorageItems).length === 0) {
        return this.tableColumnsDefault
      }
      return localStorageItems
    },
    exportDevices(type) {
      this.errorsToTranslate = []

      this.$store.commit("modals/setWaitingLoader", this.$t("Exportuji data, čekejte prosím..."))
      console.log("export", this.selectedRows)
      axios
        .post(process.env.VUE_APP_APICMS + "/exportMQTTDevices?format=" + type, this.selectedRows, {
          responseType: "blob"
        })
        .then((response) => {
          if (response.data != undefined) {
            var fileName, blob

            let fileNameSuffix = "_MQTTDevices_" + this.projectId
            if (type == "csv") {
              fileName = "export" + fileNameSuffix + ".csv"
              blob = new Blob([response.data], {
                type: "text/csv;charset=utf-8;"
              })
            } else if (type == "xlsx") {
              fileName = "export" + fileNameSuffix + ".xlsx"
              blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              })
            }

            if (window.navigator.msSaveBlob) {
              // FOR IE BROWSER
              navigator.msSaveBlob(blob, fileName)
            } else {
              // FOR OTHER BROWSERS
              var csvUrl = URL.createObjectURL(blob)
              const link = document.createElement("a")
              link.setAttribute("href", csvUrl)
              link.setAttribute("download", fileName)
              link.click()
              this.$store.commit("modals/setWaitingLoader", "")
            }
          }
        })
        .catch((error) => {
          if (error.status) {
            let err = []
            err.errors = []
            err.errors.push({
              message: error.status + " " + error.statusText
            })
            this.errorsToTranslate.push(err)
            if (this.errorsToTranslate.length > 0) {
              this.openedError = true
            }
          }
          this.$store.commit("modals/setWaitingLoader", "")
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.extended-search__toggle.open img {
  transform: rotate(-180deg);
}

.eui-short {
  display: none;
}

.eui-full {
  display: block;
}

/*
  .shadowed .eui-short {
    display: block;
  }

  .shadowed .eui-full {
    display: none;
  }
  */
</style>
